<template>
  <div class="">
    <sms-edit> </sms-edit>
  </div>
</template>

<script>
import SmsEdit from "@/components/profile/lisacomunica/sms/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    SmsEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Sms",
        path: "lisacomunica_template",
        tab: "Sms",
        level: 3,
      });
      bcs.push({
        text: "Modifica template sms",
        path: "sms.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Sms",
        path: "lisacomunica_template",
        tab: "Sms",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica template sms",
        path: "sms.edit",
        level: 4,
      });
    }
  },
};
</script>
